import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("label", {
  class: "form-label"
}, " Vpišite matično številko naročnika:", -1);

var _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "small padding-top3"
}, "Vpišite 10 mestno številko. Če nimate podenot, 7 mestni matični številki dodajte tri ničle (npr. 1234567000)", -1);

var _hoisted_3 = {
  key: 0,
  class: "padding-top10"
};
var _hoisted_4 = {
  class: "box green"
};
var _hoisted_5 = {
  class: "text-bold"
};
var _hoisted_6 = {
  class: "padding-top10"
};
var _hoisted_7 = {
  class: ""
};
var _hoisted_8 = {
  class: ""
};
var _hoisted_9 = {
  key: 1,
  class: "padding-top10"
};

var _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "small padding-top10"
}, "Z dodajanjem naročnika pridobite pravico poročanja o realiziranih plačilih iz naslova javnega naročanja za izbranega naročnika. O dodanem naročniku so prek elektronske pošte avtomatsko obveščeni vsi uporabniki, ki že imajo pravico poročanja za tega naročnika.", -1);

var _hoisted_11 = {
  class: "columns padding-top20"
};
var _hoisted_12 = {
  class: "column col-6"
};
var _hoisted_13 = {
  class: "column col-6 text-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_InputText = _resolveComponent("InputText");

  var _component_InputWrapper = _resolveComponent("InputWrapper");

  return _openBlock(), _createBlock("div", null, [_createVNode(_component_InputWrapper, {
    errors: _ctx.errorMap(_ctx.$appErrors, 'idNumber')
  }, {
    default: _withCtx(function () {
      return [_hoisted_1, _createVNode(_component_InputText, {
        modelValue: _ctx.data.idNumber,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.data.idNumber = $event;
        }),
        onItmChange: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.item = $event;
        })
      }, null, 8, ["modelValue"])];
    }),
    _: 1
  }, 8, ["errors"]), _hoisted_2, _ctx.item ? (_openBlock(), _createBlock("div", _hoisted_3, [_createVNode("div", _hoisted_4, [_createVNode("div", _hoisted_5, _toDisplayString(_ctx.item.title), 1), _createVNode("div", _hoisted_6, _toDisplayString(_ctx.item.address), 1), _createVNode("div", _hoisted_7, _toDisplayString(_ctx.item.city), 1), _createVNode("div", _hoisted_8, "DŠ: " + _toDisplayString(_ctx.item.taxNumber), 1)])])) : (_openBlock(), _createBlock("div", _hoisted_9)), _hoisted_10, _createVNode("div", _hoisted_11, [_createVNode("div", _hoisted_12, [_createVNode("button", {
    class: "button",
    onClick: _cache[3] || (_cache[3] = _withModifiers(function () {
      return _ctx.submit && _ctx.submit.apply(_ctx, arguments);
    }, ["prevent"])),
    disabled: _ctx.$appLoading
  }, "Dodaj", 8, ["disabled"])]), _createVNode("div", _hoisted_13, [_createVNode("button", {
    class: "button trans",
    onClick: _cache[4] || (_cache[4] = _withModifiers(function ($event) {
      return _ctx.$emit('close');
    }, ["prevent"]))
  }, "Zapri")])])]);
}